export default __webpack_public_path__ + "static/media/bg_finish_go_on.6031e9be.png";